import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const imagesPerPage = 12; // 4 rows x 3 columns
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/images.json`)
            .then((response) => response.json())
            .then((data) => setImages(data));
    }, []);

    // Calculate the images to display on the current page
    const indexOfLastImage = currentPage * imagesPerPage;
    const indexOfFirstImage = indexOfLastImage - imagesPerPage;
    const currentImages = images.slice(indexOfFirstImage, indexOfLastImage);

    // Handle page navigation
    const totalPages = Math.ceil(images.length / imagesPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleImageClick = (src) => {
        navigate('/image-viewer', { state: { imageSrc: process.env.PUBLIC_URL + src } });
    };

    return (
        <div className="container text-center mt-5">
            {/* Menu Bar */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container">
                    <Link className="navbar-brand" to="/">The Sol Ring</Link>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <Link className="nav-link" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/gallery">Gallery</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <h1 className="display-4">Gallery</h1>
            <div className="row">
                {currentImages.map((src, index) => (
                    <div key={index} className="col-md-3 mb-4">
                        <img
                            src={process.env.PUBLIC_URL + src}
                            alt={`Gallery ${index}`}
                            className="gallery img-fluid"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleImageClick(src)}
                        />
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-between mt-4">
                <button
                    className="btn btn-secondary"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                    className="btn btn-secondary"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Gallery;